import React from "react";

import { NotSubscribedRoute } from "../../../domains/NotSubscribed";
import { GoogleCallbackRoute } from "../../../domains/Settings/Integrations/Google/GoogleCallback";
import { GENERAL_ROUTES } from "../../routes";

export const GeneralFullPageRoutes = [
  {
    path: GENERAL_ROUTES.GoogleIntegrationCallback,
    element: <GoogleCallbackRoute />,
  },
  { path: GENERAL_ROUTES.NotSubscribed, element: <NotSubscribedRoute /> },
];
